import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './public/login/login.component';
import { RouterModule } from '@angular/router';
import { PaginationModule, PaginationConfig } from 'ngx-bootstrap/pagination';
import { INgxSelectOptions, NgxSelectModule } from 'ngx-select-ex';
import { NewPasswordComponent } from './public/new-password/new-password.component';
import { ContractDetailsComponent } from './public/contract-details/contract-details.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SharedModule } from '../shared/shared.module';
// import { DebtRecoveryModule } from './debt-recovery/debt-recovery.module';
// import { CustomersModule } from './customers/customers.module';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AssignmentsService } from './assignments/assignments.service';

const CustomSelectOptions: INgxSelectOptions = {
  // Check the interface for more options
  optionValueField: 'id',
  optionTextField: 'name',
};

@NgModule({
  declarations: [DashboardComponent, LoginComponent, NewPasswordComponent, ContractDetailsComponent, NotFoundComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    RouterModule,
    PaginationModule,
    NgxSelectModule.forRoot(CustomSelectOptions),
    InfiniteScrollDirective,
    ModalModule,
    NgxSelectModule,
    AccordionModule
  ],
  providers: [PaginationConfig, AssignmentsService],
})
export class PagesModule {}
